/* eslint-disable @typescript-eslint/no-explicit-any */

// Readable message from a Rails API error: `{ error }`, `{ message }`, `{ errors }` or `{ field: [...] }`.
// Same rules as the per-feature copies in src/actions; new features should use this one.
export const extractErrorMessage = (apiError: any): string => {
    const data = apiError?.response?.data;

    if (data && typeof data === 'object') {
        // `message` is the readable text when both are present ({ error: 'forbidden', message: '...' }).
        if (typeof data.message === 'string' && data.message) return data.message;
        if (typeof data.error === 'string' && data.error) return data.error;

        if (typeof data.errors === 'string') return data.errors;
        if (Array.isArray(data.errors) && typeof data.errors[0] === 'string') return data.errors[0];
        if (data.errors && typeof data.errors === 'object') {
            const [field] = Object.keys(data.errors);
            if (field) {
                const fieldError = data.errors[field];
                return `${field} ${Array.isArray(fieldError) ? fieldError[0] : fieldError}`;
            }
        }

        const [field] = Object.keys(data);
        const fieldError = field ? data[field] : undefined;
        if (Array.isArray(fieldError) && fieldError.length > 0) return `${field} ${fieldError[0]}`;
        if (typeof fieldError === 'string') return `${field} ${fieldError}`;
    }

    return apiError?.message || 'An unexpected error occurred';
};
